import React from 'react';
import { 
  HeroSection, 
  FeaturesSection,
  Footer, 
} from '../components';
import './HomeLanding.css';

const HomeLanding = () => {
  return (
    <div className="home-landing">
      <HeroSection />
      <FeaturesSection />
      <Footer />
    </div>
  );
};

export default HomeLanding; 